import { forEachNode } from "../../utils/forEachNode";

const scrollIntoView = (link, container, padding) => {
    if (container) {
        const linkOffsetTop = link.offsetTop;
        container.scrollTop = linkOffsetTop - padding;
    }
};

const observeHeaders = (contents) => {
    const options = {
        rootMargin: '0% 0% -80% 0%',
        threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // remove the class from those elements to which the class was added before
                const alreadyActiveLinks = document.querySelectorAll(`.navigation-link_active`);
                forEachNode(alreadyActiveLinks, (alreadyActiveLink) => {
                    alreadyActiveLink.classList.remove('navigation-link_active')
                });

                // add the class to the new elements
                const id = entry.target.id;
                const links = document.querySelectorAll(`.navigation-link_${id}`);
                forEachNode(links, (link) => {
                    link.classList.add('navigation-link_active');

                    const desktopContainer = link.closest('.info-template__sidebar');
                    const mobileContainerWrapper = link.closest('.info-template__page-navigation-links-wrapper');
                    const mobileContainer = mobileContainerWrapper?.querySelector('.info-template__page-navigation-wrapper');
                    const container = desktopContainer || mobileContainer;
                    const padding = desktopContainer ? 20 : 60;

                    scrollIntoView(link, container, padding);
                });
            }
        });
    }, options);

    contents
        .filter(content => content.tagName === 'H3' || content.tagName === 'H4')
        .forEach(content => observer.observe(content));
}

const getElements = () => {
    return {
        titleWrapper: document.querySelector('.info-template__page-navigation-title-wrapper'),
        titleChevrons: document.querySelectorAll('.info-template__page-navigation-icon'),
        article: document.querySelector('.info-template__content'),
        contentsWrappers: document.querySelectorAll('.info-template__page-navigation-links'),
        contents: Array.from(document.querySelector('.info-template__content')?.getElementsByTagName('*') || [])
    }
}

const createLinkElement = (id, text) => {
    const link = document.createElement('a');
    link.href = `#${id}`;
    link.textContent = text;
    link.classList.add('info-template__page-navigation-link');
    link.classList.add(`navigation-link_${id}`);
    return link;
}

const createSubList = (items) => {
    const subLinksWrapper = document.createElement('ul');
    subLinksWrapper.classList.add('info-template__page-navigation-sublist');
    items.forEach(item => subLinksWrapper.appendChild(item));
    return subLinksWrapper;
}

const createListItem = (link) => {
    const listElem = document.createElement('li');
    listElem.classList.add('info-template__page-navigation-sublist-elem');
    listElem.append(link);
    return listElem;
}

const createNodesFromContents = (contents) => {
    const nodes = document.createElement('nav');
    nodes.classList.add('info-template__page-navigation-wrapper');

    const sublist = contents.reduce((acc, element, index) => {
        const {tagName: tag, textContent: text} = element;

        // create a link for every header
        if (tag == 'H3' || tag == 'H4') {
            const id = `Tag${index}`

            element.id = id;

            const link = createLinkElement(id, text);

            if (tag == 'H3') {
                if (acc.length > 0) {
                    nodes.appendChild(createSubList(acc));
                    acc = [];
                }

                nodes.appendChild(link);
            }

            if (tag == 'H4') {
                acc = [...acc, createListItem(link)];
            }
        }

        return acc;
    }, []);

    if (sublist.length > 0) {
        nodes.appendChild(createSubList(sublist));
    }

    return nodes;
}

const appendNodesToContentsWrappers = (nodes, contentsWrappers) => {
    forEachNode(
        contentsWrappers,
        (contentsWrapper) => contentsWrapper.appendChild(nodes.cloneNode(true))
    );
}

const toggleLinks = (titleChevrons) => {
    const mobileLinksWrapper = document.querySelector('.info-template__page-navigation-links-wrapper');
    const mobileLinks = mobileLinksWrapper.querySelector('.info-template__page-navigation-wrapper');

    const isAlreadyActive = mobileLinks.classList.contains('info-template__page-navigation-wrapper_active');

    mobileLinks.classList.toggle(
        'info-template__page-navigation-wrapper_active',
        !isAlreadyActive
    )

    forEachNode(titleChevrons, (chevron) => chevron.classList.toggle('info-template__page-navigation-icon_active'));
}

export class InfoTemplateArticleContents {
    constructor() {
        const { titleWrapper, titleChevrons, contentsWrappers, contents } = getElements();
        const nodes = createNodesFromContents(contents);

        appendNodesToContentsWrappers(nodes, contentsWrappers);
        observeHeaders(contents);

        if (titleWrapper) {
            titleWrapper.addEventListener('click', () => toggleLinks(titleChevrons));
        }

        // close contents when clicking on a link
        document.addEventListener('click', (event) => {
            if (event.target.classList.contains('info-template__page-navigation-link')) {
                toggleLinks(titleChevrons);
            }
        });

        document.addEventListener('click', function(event) {
            const { target } = event;
            if (target.tagName.toLowerCase() === 'a') {
                const id = target.hash.slice(1);
                const url = target.href;
                const element = document.getElementById(id);
                if (element && window.location.href.indexOf(url)===false) {
                    event.preventDefault();
                    const percentOfHeight = window.innerHeight * 0.01;
                    const mobileContentsWrapper = document.querySelector('.info-template__page-navigation-links-wrapper');
                    const headerHeight = mobileContentsWrapper.getBoundingClientRect().height;
                    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                    window.scrollTo({
                        top: elementPosition - headerHeight - (percentOfHeight * 10),
                        behavior: 'smooth',
                    });
                }
            }
        });
    }
}
